

export default function DotC(){
    return(
      <div className="px-c5 font-light text-gray-400">.</div>

    )
}